import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { UserActionDirectivesModule } from "../user-action-directives";
import { AlertModalComponent } from "./alert-modal.component";
import { ConfirmationModalComponent } from "./confirmation-modal.component";
import { ModalContainerComponent } from "./modal-container.component";
import { ModalTemplateDirective } from "./modal-template.directive";

@NgModule({
  imports: [CommonModule, UserActionDirectivesModule],
  declarations: [
    AlertModalComponent,
    ConfirmationModalComponent,
    ModalContainerComponent,
    ModalTemplateDirective
  ],
  entryComponents: [
    AlertModalComponent,
    ConfirmationModalComponent,
    ModalContainerComponent
  ],
  exports: [ModalTemplateDirective]
})
export class ModalComponentsModule {}
